import { Modal, Button, notification, Typography, Row } from "antd";
import PropTypes from "prop-types";
import { useLoader } from "../../../context/LoaderContext";
import axiosInstance from "../../../utils/axios";
import { InfoCircleOutlined } from "@ant-design/icons";
import classes from "./modals.module.css";
import { useContext } from "react";
import GlobalContext from "../../../context/GlobalContext";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
const ModalAcceptFermeture = (props) => {
  const { openConfirmModal, setOpenConfirmModal, openModalFermereture } = props;
  const { setIsLoading } = useLoader();
  const { form } = useContext(GlobalContext);
  const navigate = useNavigate();
  const registration_number_for_annulation = sessionStorage.getItem(
    "registration_number_for_annulation"
  );
  const handleCancel = () => {
    setOpenConfirmModal(false);
  };

  const handleConfirm = () => {
    setIsLoading(true);
    const payload = {
      motif: form.getFieldsValue()["motif"],
      registation_number: registration_number_for_annulation,
    };
    if (form.getFieldsValue()["typeFermeture"] === "provisoire") {
      (payload.date_fermeture = dayjs(
        form.getFieldsValue()["dateFermeture"]
      ).format("YYYY-MM-DD")),
        (payload.date_reprise = dayjs(
          form.getFieldsValue()["dateReprise"]
        ).format("YYYY-MM-DD"));
    }

    axiosInstance
      .post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/annulation_demandes_by_EPF`,
        payload,

        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        navigate("/demandes");
        notification.success({
          message: "Succès",
          description: "Toutes les demandes en cours ont été annulées.",
          duration: 0,
        });
      })
      .catch((error) => {
        notification.error({
          message: "Erreur",
          description:
            "Une erreur s'est produite lors de l'annulation des demandes.",
          duration: 0,
        });
      });
  };

  return (
    <Modal
      title="Confirmation de fermeture provisoire d’un EPF"
      open={openConfirmModal}
      onCancel={handleCancel}
      width={800}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Annuler
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          J’accepte
        </Button>,
      ]}
      centered
      style={{ textAlign: "center" }}
    >
      <Typography.Paragraph className={classes.modalText}>
        On validant la fermeture provisoire de l’établissement de formation,
        Toutes les demandes en cours liées à l'EPF concerné seront annulées
      </Typography.Paragraph>

      <Row
        style={{
          marginTop: "2rem",
          backgroundColor: "#f0f5ff",
          padding: "1rem",
          borderRadius: "4px",
        }}
      >
        <Typography.Text className={classes.infoTetx}>
          <InfoCircleOutlined
            style={{ marginRight: "8px", color: "#1890ff" }}
          />
          Vous disposez de 15 jours pour revenir sur votre décision. Durant
          cette période, vous pouvez :
          <ul>
            <li>
              soit annuler la demande en se rendant dans la rubrique "Mes
              demandes" et en sélectionnant l’option "Annuler"
            </li>
            <li>
              soit mettre à jour la date de reprise en cliquant sur le bouton
              “Modifier la date de reprise”.
            </li>
          </ul>
        </Typography.Text>
      </Row>
    </Modal>
  );
};

ModalAcceptFermeture.propTypes = {
  openConfirmModal: PropTypes.bool.isRequired,
  setOpenConfirmModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

export default ModalAcceptFermeture;
